export const cloneArray = items => {
  return items.map(item =>
    Array.isArray(item) ? this.cloneArray(item) : { ...item }
  );
};
